import {TreeSelectWithoutContainer} from "../../../../component/TreeSelect/TreeSelect";
import {useEffect, useState} from "react";
import {
    convertAreaObjectToArray,
    getAllTownsDividedByAreaBlock,
    getFilteredAllTownsDividedByAreaBlock
} from "../../functions";
import Loading from "../../../../component/Loading/Loading";
import {listToTree} from "../../../../assets/functions";

const AreaBlockTreeSelect = ({removeArea = {
    isAllIsland: "FALSE",
    includeAreaBlock: [],
    excludeAreaBlock: [],
    includeTown :[],
    excludeTown: [],
} , selectedArea , onChange , ...rest}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [allTownsObject, setAllTownsObject] = useState([]);

    useEffect(() => {
        (async () => {
            const allTowns = await getAllTownsDividedByAreaBlock();
            setAllTownsObject(allTowns);
            setIsLoading(false);
        })();
    }, []);

    if (isLoading)
        return <Loading/>


    return (
        <TreeSelectWithoutContainer {...rest}
                                    onChange={(value) => (onChange(value))}
                                    data={listToTree(getFilteredAllTownsDividedByAreaBlock(allTownsObject , removeArea) , convertAreaObjectToArray(selectedArea))}

        />
    );
}

export default AreaBlockTreeSelect;